import styled from 'styled-components';
import colors from 'constants/colors';

export const RatePlanTableContainer = styled.table`
  width: 100%;
  color: ${colors.white};
  border-collapse: collapse;
  font-size: 14px;

  tr {
    height: 40px;
    &:nth-child(odd) {
      background-color: ${colors.black1};
    }

    &:nth-child(even) {
      background-color: ${colors.black5};
    }
  }

  th {
    height: 50px;
    vertical-align: bottom;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.5px;
    padding: 8px 15px;
    border-bottom: 2px solid ${colors.white};
    border-top: 1px solid ${colors.dimGrey};
  }

  td {
    border: 1px solid ${colors.charcoal};
    padding: 8px 15px;
    :first-child {
      border-left: none;
    }
  }

  .date-column {
    width: 14%;
  }

  .customer-column {
    width: 27%;
  }

  .amountPaid-column {
    width: 9%;
  }

  .tax-column {
    width: 7%;
  }
`;
